import { render, staticRenderFns } from "./BenefitsWorkingWithUsBlock.vue?vue&type=template&id=1bfc87fa&scoped=true&"
import script from "./BenefitsWorkingWithUsBlock.vue?vue&type=script&lang=js&"
export * from "./BenefitsWorkingWithUsBlock.vue?vue&type=script&lang=js&"
import style0 from "./BenefitsWorkingWithUsBlock.vue?vue&type=style&index=0&id=1bfc87fa&prod&lang=scss&scoped=true&"
import style1 from "./BenefitsWorkingWithUsBlock.vue?vue&type=style&index=1&id=1bfc87fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfc87fa",
  null
  
)

export default component.exports